
import Vue from "vue";
import InceptionDashboardNumbers from "@/components/recruiter/dashboard/InceptionDashboardNumbers.vue";
import { mapGetters } from "vuex";
import {
  GET_USER_DETAILS,
  GET_COMPANY_DETAILS
} from "@/store/modules/auth/constants";

export default Vue.extend({
  name: "InceptionRecruiterDashboard",
  components: {
    InceptionDashboardNumbers
  },
  data() {
    return {
      hello_illustration: require("@/assets/illustrations/waving-hand.svg")
    };
  },
  computed: {
    ...mapGetters("auth", {
      user: GET_USER_DETAILS,
      companyDetail: GET_COMPANY_DETAILS
    }),
    /**
     * English assessment reports path using the version selected in Settings (Candidates > English).
     * e.g. English V5 selected -> /recruiter/assessments/english/v5
     */
    englishAssessmentReportsPath(): string {
      const eng =
        this.companyDetail?.storage_path?.assessment_setting
          ?.candidates_english;
      const version = eng ? eng.replace("english_", "") : "v4";
      return `/recruiter/assessments/english/${version}`;
    }
  },
  async mounted() {
    //
  },
  methods: {}
});
